import Api from '@teko/api';
import { accessTokenInterceptor } from '@teko/auth';
import i18next from 'i18next';

var PaymentMethodCode;
(function (PaymentMethodCode) {
    PaymentMethodCode["COD"] = "COD";
    PaymentMethodCode["COD_OFFLINE"] = "COD_OFFLINE";
    PaymentMethodCode["VNPAYQR"] = "VNPAYQR";
    PaymentMethodCode["VNPAY_GATEWAY"] = "VNPAY_GATEWAY";
    PaymentMethodCode["CTT"] = "CTT";
    PaymentMethodCode["MOBILE_BANKING"] = "MOBILE_BANKING";
    PaymentMethodCode["LOYALTY"] = "LOYALTY";
    PaymentMethodCode["CASH"] = "CASH";
    PaymentMethodCode["VNPAY_TOKEN"] = "VNPAY_TOKEN";
    PaymentMethodCode["ALEPAY_INSTALLMENT_CREDIT"] = "ALEPAY_INSTALLMENT_CREDIT";
    PaymentMethodCode["VNPAY_INSTALLMENT_CREDIT"] = "VNPAY_INSTALLMENT_CREDIT";
    PaymentMethodCode["PAYBILL"] = "PAYBILL";
})(PaymentMethodCode || (PaymentMethodCode = {}));
var PaymentMethodGroupCode;
(function (PaymentMethodGroupCode) {
    PaymentMethodGroupCode["CREDIT"] = "CREDIT";
    PaymentMethodGroupCode["INSTALLMENT"] = "INSTALLMENT";
    PaymentMethodGroupCode["CARD"] = "CARD";
    PaymentMethodGroupCode["OFFLINE"] = "OFFLINE";
    PaymentMethodGroupCode["LOYALTY"] = "LOYALTY";
})(PaymentMethodGroupCode || (PaymentMethodGroupCode = {}));
var PaymentCardType;
(function (PaymentCardType) {
    PaymentCardType[PaymentCardType["REDIRECT_URL_THANH_TOAN"] = 1] = "REDIRECT_URL_THANH_TOAN";
    PaymentCardType[PaymentCardType["GEN_QR_CONG"] = 2] = "GEN_QR_CONG";
})(PaymentCardType || (PaymentCardType = {}));

var viLang = {
	"Thanh toán trực tuyến": "Thanh toán trực tuyến",
	"Thanh toán Online qua cổng VNPAY": "Thanh toán Online qua cổng VNPAY",
	"Thanh toán khi nhận hàng": "Thanh toán khi nhận hàng",
	"Tiêu điểm thành viên": "Tiêu điểm thành viên",
	"Tiền mặt": "Tiền mặt",
	"Thanh toán trả góp": "Thanh toán trả góp"
};

var enLang = {
	"Thanh toán trực tuyến": "Online payment",
	"Thanh toán Online qua cổng VNPAY": "Online payment via VNPAY",
	"Thanh toán khi nhận hàng": "Cash on delivery (COD)",
	"Tiêu điểm thành viên": "Point redemtion",
	"Tiền mặt": "Cash",
	"Thanh toán trả góp": "Installment"
};

const NAMESPACE = 'payment';
const t = (keys, options) => {
    return i18next.t(keys, Object.assign(Object.assign({}, options), { ns: NAMESPACE, interpolation: { escapeValue: false } }));
};
const lang = {
    vi: viLang,
    en: enLang,
};

const getPaymentMethod = (paymentMethodCode) => {
    if (!paymentMethodCode) {
        return '';
    }
    switch (paymentMethodCode.toUpperCase()) {
        case PaymentMethodCode.VNPAYQR:
        case PaymentMethodCode.VNPAY_GATEWAY:
        case PaymentMethodCode.MOBILE_BANKING:
        case PaymentMethodCode.PAYBILL:
            return t('Thanh toán trực tuyến');
        case PaymentMethodCode.CTT:
            return t('Thanh toán Online qua cổng VNPAY');
        case PaymentMethodCode.COD:
            return t('Thanh toán khi nhận hàng');
        case PaymentMethodCode.LOYALTY:
            return t('Tiêu điểm thành viên');
        case PaymentMethodCode.CASH:
            return t('Tiền mặt');
        case PaymentMethodCode.VNPAY_INSTALLMENT_CREDIT:
        case PaymentMethodCode.ALEPAY_INSTALLMENT_CREDIT:
            return t('Thanh toán trả góp');
        default:
            return paymentMethodCode || '';
    }
};
const sha256 = async (message) => {
    const msgBuffer = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
        .map((b) => ('00' + b.toString(16)).slice(-2))
        .join('');
    return hashHex;
};
const checksumGenerator = async (secretKey, body) => {
    if (!body) {
        return;
    }
    const fields = [
        'orderCode',
        'userId',
        'terminalCode',
        'merchantCode',
        'totalPaymentAmount',
        'successUrl',
        'cancelUrl',
    ];
    const hashData = [];
    fields.forEach((f) => {
        hashData.push(body[f] || '');
    });
    const { loyalty, card, qr, credit, offline, installment } = body.payments;
    const arrayPayments = [loyalty, card, qr, credit, offline, installment];
    arrayPayments.forEach((p) => {
        if (p) {
            hashData.push(p.clientTransactionCode);
            hashData.push(p.merchantMethodCode);
            hashData.push(p.methodCode);
            hashData.push(p.amount);
        }
    });
    const hashString = hashData.join('|');
    return sha256(secretKey + hashString);
};
const checksumGeneratorCreateToken = (secretKey, body) => {
    if (!body) {
        return;
    }
    const { merchantMethodCode, clientTransactionCode, userId, successUrl, cancelUrl, cardType, bankCode, } = body;
    const str = [
        merchantMethodCode,
        clientTransactionCode,
        successUrl,
        cancelUrl,
        cardType,
        bankCode,
        userId,
    ].join('|');
    return sha256(secretKey + str);
};
const checksumGeneratorRemoveToken = (secretKey, body) => {
    if (!body) {
        return;
    }
    const { merchantMethodCode, clientTransactionCode, userId, token } = body;
    const str = [merchantMethodCode, clientTransactionCode, userId, token].join('|');
    return sha256(secretKey + str);
};

const defaultRedirectUrl = 'https://vnshop.stag.teko.vn';
const generateRandom = () => Math.random().toString(36).substring(7);
const cyrb53 = (str, seed = 0) => {
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for (let i = 0, ch; i < str.length; i++) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 =
        Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^
            Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 =
        Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^
            Math.imul(h1 ^ (h1 >>> 13), 3266489909);
    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
};
const genClientTransactionCode = (orderId, methodGroupCode) => {
    const date = new Date();
    return cyrb53(`${orderId}${methodGroupCode}${date.getDate()}${date.getHours()}${date.getMinutes()}`)
        .toString()
        .replace('-', 'm');
};
const getInitPaymentType = (type, bankCode) => {
    if (!type || (['ATM', 'VISA'].includes(type) && bankCode))
        return PaymentCardType.REDIRECT_URL_THANH_TOAN;
    return PaymentCardType.GEN_QR_CONG;
};
class PaymentService {
    constructor(paymentURL, envSecretKey, paymentSettingURL = null) {
        this.initPaymentAIOOffline = async (body) => {
            const checksum = await checksumGenerator(this.envSecretKey, body);
            const requestData = Object.assign(Object.assign({}, body), { checksum });
            const res = await this.paymentApi.post('/payment/init/multi-staff', requestData);
            return res.data;
        };
        this.initPaymentAIOnline = async (body) => {
            var _a;
            const checksum = await checksumGenerator(this.envSecretKey, body);
            const requestData = Object.assign(Object.assign({}, body), { checksum, type: 1 });
            const { data } = await this.paymentApi.post('/payment/init/multi-v2', requestData);
            const paymentData = (_a = data === null || data === void 0 ? void 0 : data.payments) === null || _a === void 0 ? void 0 : _a.installment;
            if (paymentData === null || paymentData === void 0 ? void 0 : paymentData.postData) {
                const postData = paymentData === null || paymentData === void 0 ? void 0 : paymentData.postData;
                const form = document.createElement('form');
                form.action = paymentData === null || paymentData === void 0 ? void 0 : paymentData.returnUrl;
                form.method = 'POST';
                form.target = '_self';
                (postData === null || postData === void 0 ? void 0 : postData.parameters) &&
                    Object.keys(postData === null || postData === void 0 ? void 0 : postData.parameters).forEach((key) => {
                        var _a;
                        const hiddenField = document.createElement('input');
                        hiddenField.type = 'hidden';
                        hiddenField.name = key;
                        hiddenField.value = (_a = postData === null || postData === void 0 ? void 0 : postData.parameters) === null || _a === void 0 ? void 0 : _a[key];
                        form.appendChild(hiddenField);
                    });
                document.body.appendChild(form);
                form.submit();
            }
            return data;
        };
        this.getBankAccounts = async () => {
            var _a;
            const res = await this.paymentApi.get(`/settings/banks/accounts`);
            return (_a = res.data) === null || _a === void 0 ? void 0 : _a.data;
        };
        this.requestCreateToken = async (merchantMethodCode, userId, cardType, successUrl, cancelUrl) => {
            const isLocalhost = successUrl.includes('localhost');
            const payload = {
                merchantMethodCode,
                clientTransactionCode: generateRandom(),
                userId,
                successUrl: isLocalhost ? defaultRedirectUrl : successUrl,
                cancelUrl: isLocalhost ? defaultRedirectUrl : cancelUrl,
                cardType,
                bankCode: '',
            };
            const checksum = await checksumGeneratorCreateToken(this.envSecretKey, payload);
            const { data } = await this.paymentSettingApi.post('/payment/init/tokencreate', Object.assign(Object.assign({}, payload), { checksum }));
            return data;
        };
        this.requestRemoveToken = async (merchantMethodCode, userId, token) => {
            const payload = {
                merchantMethodCode,
                clientTransactionCode: generateRandom(),
                userId,
                token,
            };
            const checksum = await checksumGeneratorRemoveToken(this.envSecretKey, payload);
            const { data } = await this.paymentSettingApi.post('/payment/token/remove', Object.assign(Object.assign({}, payload), { checksum }));
            return data;
        };
        this.payForOrderOnline = async ({ terminalCode, order, userId, successUrl, cancelUrl, payment, loyalty, deposit, }) => {
            var _a;
            const { methodCode, methodGroupCode, merchantCode, type, bankCode, token } = payment;
            const isDeposit = PaymentMethodCode.COD !== methodCode && deposit && deposit.payNowAmount;
            const loyaltyAmount = (loyalty && loyalty.amount) || 0;
            const orderCode = order.originalCode || order.code;
            const prevPayment = ((_a = order === null || order === void 0 ? void 0 : order.payments) === null || _a === void 0 ? void 0 : _a.reduce((amount, currentPayment) => amount + currentPayment.amount, 0)) || 0;
            const netAmount = order.grandTotal - (order.totalPaid || 0) - loyaltyAmount - prevPayment;
            const cardTypeInfo = methodGroupCode.toUpperCase() === PaymentMethodGroupCode.CARD
                ? Object.assign({ type: getInitPaymentType(type, bankCode) }, (methodCode === PaymentMethodCode.VNPAY_TOKEN && { token })) : {};
            const paymentData = Object.assign(Object.assign({ [methodGroupCode.toLowerCase()]: Object.assign(Object.assign(Object.assign(Object.assign({}, payment), { amount: isDeposit ? deposit.payNowAmount : netAmount }), cardTypeInfo), { clientTransactionCode: genClientTransactionCode(orderCode, methodGroupCode) }) }, (!!loyaltyAmount && {
                loyalty: Object.assign(Object.assign({}, loyalty), { clientTransactionCode: genClientTransactionCode(orderCode, PaymentMethodGroupCode.LOYALTY) }),
            })), (isDeposit &&
                Math.round(deposit.payNowAmount) !== Math.round(netAmount) && {
                credit: {
                    merchantMethodCode: deposit.method.merchantMethodCode,
                    methodCode: deposit.method.methodCode,
                    clientTransactionCode: genClientTransactionCode(orderCode, PaymentMethodGroupCode.CREDIT),
                    amount: netAmount - deposit.payNowAmount,
                },
            }));
            const data = {
                orderCode,
                userId,
                merchantCode,
                terminalCode,
                totalPaymentAmount: order.grandTotal - (order.totalPaid || 0),
                totalPaymentWithoutFee: order.grandTotal - (order.totalPaid || 0) - (order.totalFee || 0),
                successUrl,
                cancelUrl,
                payments: Object.keys(paymentData)
                    .filter((key) => paymentData[key].amount > 0)
                    .reduce((res, key) => ((res[key] = paymentData[key]), res), {}),
            };
            return await this.initPaymentAIOnline(data);
        };
        this.paymentURL = paymentURL;
        this.envSecretKey = envSecretKey;
        this.paymentApi = new Api(paymentURL);
        this.paymentApi.addInterceptor(accessTokenInterceptor);
        if (paymentSettingURL) {
            this.paymentSettingApi = new Api(paymentSettingURL);
            this.paymentSettingApi.addInterceptor(accessTokenInterceptor);
        }
    }
}

export { NAMESPACE, PaymentCardType, PaymentMethodCode, PaymentMethodGroupCode, PaymentService, checksumGenerator, checksumGeneratorCreateToken, checksumGeneratorRemoveToken, getPaymentMethod, lang, sha256 };
